import { render } from "./WaSesionsView.vue?vue&type=template&id=676d0887"
import script from "./WaSesionsView.vue?vue&type=script&lang=js"
export * from "./WaSesionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__